import React, { useState, useEffect } from "react";
import HSTable from "../../components/global/Table";
import { getAllPhcDeaerators } from '../../services/dearators_phc/DeaeratorPhcService';
import IconButton from '@mui/material/IconButton';
import { Search } from "@mui/icons-material";
import DeaeratorPhcDetail from '../../components/dearators_phc/DeaeratorPhcDetail';
import Deaerotor from "../../assets/deaerotor_card.png";

const DeaeratorsPhcPage = () => {

    const columns = [
        { field: "number", label: "Excel No", sortable: true },
        { field: "client", label: "Cliente", sortable: true },
        { field: "contract", label: "Contrato", sortable: true },
        {
            field: "deaeratorPhcType",
            label: "Tipo",
            sortable: true,
            render: (value) => (
                value === 'CONTRACT' ? "Contrato" : "Proposta"
            ),
        },
        {
            field: "actions",
            label: "Ver Detalhes",
            align: "left",
            paddingLeft: 5,
            render: (_, row) => (
                <IconButton onClick={() => handleViewDetails(row)}>
                    <Search fontSize="medium" sx={{ color: "primary.main" }} />
                </IconButton>
            ),
        },
    ];

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalElements, setTotalElements] = useState(0);
    const [selectedId, setSelectedId] = useState('');
    const [searchString, setSearchString] = useState('');
    const [deaerator, setDeaeratorInDetail] = useState({});

    useEffect(() => {
        (async () => {
            await getAllPhcDeaerators(page, rowsPerPage, searchString).then(res => {
                setTotalElements(res.totalElements);
                setData(res.content);
                setLoading(false);
            });
        })();
    }, [page, rowsPerPage, searchString]);

    const handleViewDetails = (deaerator) => {
        setSelectedId(deaerator['id']);
        let obj = deaerator;
        obj['image'] = Deaerotor;
        setDeaeratorInDetail(obj);
    }

    const onSearchChange = (search) => {
        setSearchString(search);
    }

    return (
        <>
            <div style={{ boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)' }}>
                <HSTable
                    columns={columns}
                    data={data}
                    loading={loading}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    enableSearch={true}
                    totalCount={totalElements}
                    onRowsPerPageChange={(newRowsPerPage) => {
                        setRowsPerPage(newRowsPerPage);
                        setPage(0);
                    }}
                    onPageChange={(page) => setPage(page)}
                    onSearchChange={onSearchChange}
                />
            </div>

            {selectedId !== '' &&
                <DeaeratorPhcDetail
                    deaerator={deaerator}
                    onClose={() => setSelectedId('')}
                />
            }
        </>
    );
}

export default DeaeratorsPhcPage;